import leftNav from '@/components/leftNav.vue'
export default {
    components: {
        "left-nav":leftNav,
    },
    data() {
        return {
          info:{},
          provinceArr:[],
          cityArr:[],
          zoneArr:[],
          companyType: [{
              value: 1,
              name: '甲方'
            }, {
              value: 8,
              name: '施工总包'
            }, {
              value: 2,
              name: '专业分包'
            }, {
              value: 3,
              name: '中介咨询'
            }, {
              value: 4,
              name: '设计院'
            }, {
              value: 5,
              name: '政府部门'
            }, {
              value: 6,
              name: '个人'
            }, {
              value: 7,
              name: '其他'
            }],
          workType: [{
              value: 2,
              name: '造价'
            }, {
              value: 3,
              name: '采购'
            }, {
              value: 4,
              name: '设计院'
            }, {
              value: 1,
              name: '设计'
            }, {
              value: 5,
              name: '施工'
            }, {
              value: 6,
              name: '其他'
            }],
            }
    },
    computed:{
        userInfo:function(){
            return this.$store.state.userInfo
        }
    },
    mounted() {
      this.init()
    },
    methods: {
        init(){
          this.$axios.get("/member/userInfo/myBasicInfo").then(res=>{
                this.info=res.data.data.userInfo
                if (this.info.city) {
                  this.initCity(1)
                }
                if (this.info.zone) {
                  this.initZone(1)
                }
          })
          this.$axios.get("/member/location/province").then(res=>{
                this.provinceArr=res.data.data
          })
        },
        confirm(){
          this.$axios.post("/member/userInfo/updateUserInfo",this.info).then(res=>{
                if (res.data.code==200) {
                  this.$message({
                      type: 'success',
                      offset: 300,
                      message: '保存成功!'
                  });
                  this.init()
                }
          })
          this.$util.userBehavior(1041)
        },
        initCity(num){
          if (!num==1) {
            this.info.city=''
            this.info.zone=''
          }
          this.$axios.get("/member/location/cityThree?provinceCode="+this.info.province).then(res=>{
                this.cityArr=res.data.data
          })
        },
        initZone(num){
          if (!num==1) {
            this.info.zone=''
          }
          this.$axios.get("/member/location/zoneThree?zoneCode="+this.info.city).then(res=>{
                this.zoneArr=res.data.data
          })
        },
    },
}